/**
 * The human-readable messages of a FastAPI 422 validation detail list,
 * joined, or undefined for any other shape. Without this, a list-shaped
 * detail fell into customFetch's object branch and every validation error
 * read "Request failed". FastAPI emits one entry per invalid field, so
 * every message is kept, not just the first. Pure module so it stays
 * testable without the window-touching client import chain.
 */
export function validationDetailMessage(detail: unknown): string | undefined {
  if (!Array.isArray(detail)) return undefined
  const messages = detail
    .filter(
      (entry): entry is { msg: string } =>
        entry !== null &&
        typeof entry === 'object' &&
        'msg' in entry &&
        typeof (entry as { msg: unknown }).msg === 'string'
    )
    .map(entry => entry.msg)
  return messages.length > 0 ? messages.join('; ') : undefined
}
